import React, { useEffect } from "react";
import Header from "./../components/Header";
import ShopSection from "./../components/homeComponents/ShopSection";
import ContactInfo from "./../components/homeComponents/ContactInfo";
import CalltoActionSection from "./../components/homeComponents/CalltoActionSection";
import Footer from "./../components/Footer";
import { Topbar } from "../components/Topbar";
import MenusHeader from "../components/MenusHeader";
import { ListCateHome } from "../components/ListCateHome";
import { Slider } from "../components/Slider";
import { GridBanel3 } from "../components/GridBanel3";
import { TabCollection } from "../components/TabCollection";
import { GridBanel2 } from "../components/GridBanel2";
import { GridCollection } from "../components/GridCollection";
import { GridBanel1 } from "../components/GridBanel1";
import { SliderCollection } from "../components/SliderCollection";
import { FeedbackHome } from "../components/FeedbackHome";
import { PostCollection } from "../components/PostCollection";
import { Partners } from "../components/Partners";
import { Subscription } from "../components/Subscription";
import { listProduct } from "../redux/Actions/ProductActions";
import { useDispatch } from "react-redux";

const HomeScreen = () => {
  window.scrollTo(0, 0);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listProduct());
    return () => {

    };
  }, [dispatch]);
  return (
    <div>


      {/* <ListCateHome /> */}
      <Slider />
      <GridBanel3 />
      <div className="mt-8"> <TabCollection /></div>
      <div className="mt-8">   <GridBanel2 /></div>
      <div className="mt-8">   <GridCollection /></div>
      <div className="mt-8">   <GridBanel1 /></div>
      <div className="mt-8">   <SliderCollection /></div>
      {/* <div className="mt-8">   <FeedbackHome /></div> */}
      {/* <div className="">   <PostCollection /></div> */}
      {/* <div className="mt-8">   <Partners /></div> */}



      {/* <ShopSection />
      <CalltoActionSection />
      <ContactInfo />
      <Footer /> */}
    </div>
  );
};

export default HomeScreen;
